/* unplugin-vue-components disabled */import { render } from "./BlackWhiteDotRender.vue?vue&type=template&id=4da5575c&scoped=true"
import script from "./BlackWhiteDotRender.vue?vue&type=script&lang=js"
export * from "./BlackWhiteDotRender.vue?vue&type=script&lang=js"

import "./BlackWhiteDotRender.vue?vue&type=style&index=0&id=4da5575c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da5575c"]])

export default __exports__